import { Link } from 'react-router-dom';
import { AuthAsideContent } from './AuthWellnessVisual';

interface Props {
  title: string;
  subtitle?: string;
  step: number;
  steps: string[];
  children: React.ReactNode;
}

export function OnboardingShell({ title, subtitle, step, steps, children }: Props) {
  const progressPct = Math.round(((step + 1) / steps.length) * 100);

  return (
    <div className="auth-page">
      <aside className="auth-aside">
        <div className="auth-aside-inner">
          <Link to="/" className="auth-brand">
            <span className="auth-brand-mark" aria-hidden>
              ◉
            </span>
            Mylighthouse
          </Link>
          <AuthAsideContent variant="onboarding" />
        </div>
        <div className="auth-aside-glow auth-aside-glow-1" aria-hidden />
        <div className="auth-aside-glow auth-aside-glow-2" aria-hidden />
      </aside>

      <div className="auth-main auth-main-onboarding">
        <div className="auth-main-top">
          <Link to="/therapist/dashboard" className="auth-back">
            Save & exit
          </Link>
        </div>

        <div className="auth-card auth-card-wide">
          <div className="auth-card-header">
            <h1 className="auth-title">{title}</h1>
            {subtitle && <p className="auth-subtitle">{subtitle}</p>}
            <div className="auth-onboarding-steps">
              {steps.map((label, i) => (
                <div key={label} className="auth-onboarding-step">
                  <div
                    className={i < step ? 'step-done' : i === step ? 'step-active' : 'step-pending'}
                  >
                    {i < step ? '✓' : i + 1}
                  </div>
                  <span className={`auth-onboarding-step-label ${i === step ? 'active' : ''}`}>
                    {label}
                  </span>
                  {i < steps.length - 1 && (
                    <div className={`step-line ${i < step ? 'step-line-done' : ''}`} />
                  )}
                </div>
              ))}
            </div>
            <div className="auth-progress mt-4">
              <div className="auth-progress-track">
                <div className="auth-progress-fill" style={{ width: `${progressPct}%` }} />
              </div>
              <span className="auth-progress-label">
                Step {step + 1} of {steps.length}
              </span>
            </div>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
